import { apiFetch } from './api'
import { getToken } from './auth'
import type { DocumentRef } from './documentReader'

export interface DocumentMetadata extends DocumentRef {
  original_filename: string
  document_type: string | null
  document_date: string | null
  issuer_name: string | null
  source_language: string | null
  status: string
  page_count: number | null
  source_page_start?: number | null
  source_page_end?: number | null
  file_size: number
  created_at: string
}

let sessionIdentity: string | null = null
const metadata = new Map<string, Promise<DocumentMetadata>>()

export function clearDocumentMetadata(): void {
  metadata.clear()
  sessionIdentity = getToken()
}

export function loadDocumentMetadata(id: string): Promise<DocumentMetadata> {
  const token = getToken()
  if (sessionIdentity !== token) clearDocumentMetadata()
  let pending = metadata.get(id)
  if (!pending) {
    pending = apiFetch<DocumentMetadata>(`/api/documents/${encodeURIComponent(id)}`)
    metadata.set(id, pending)
    pending.catch(() => {
      if (metadata.get(id) === pending) metadata.delete(id)
    })
    if (metadata.size > 200) metadata.delete(metadata.keys().next().value as string)
  }
  return pending
}

if (typeof window !== 'undefined') {
  window.addEventListener('nolos-auth-changed', clearDocumentMetadata)
  window.addEventListener('storage', (event) => {
    if (event.key === 'nolos_jwt') clearDocumentMetadata()
  })
}
